<template>
  <div class="attachments-step">
    <naj-box :title="local.attachments.title">
      <v-row>
        <v-col
          cols="1"
          class="add-attachment"
        >
          <naj-button
            :disabled="isViewMode"
            icon="mdi-plus"
            @click="showGeneralAttachmentModal"
          >
            {{ local.bankruptcy.addAttachment }}
          </naj-button>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="attachments-list col col-lg-4 col-sm-12 col-12">
          <attachments-list
            :attachments="attachments.data"
            :attachment-types="attachmentTypes"
            @attachmentSelected="attachmentSelected"
            @show-attachment-modal="showAttachmentModal"
            @deleteAttachment="deleteAttachment"
          ></attachments-list>
        </v-col>

        <v-col
          v-if="selectedAttachment"
          class="attachment-file-viewer"
        >
          <v-row class="attachment-row">
            <div class="pdf-container">
              <embed
                class="pdf-viewer"
                :src="fileUrl"
              >
            </div>
          </v-row>
        </v-col>
      </v-row>
    </naj-box>
    <v-row>
      <v-col
        cols="12"
        class="text-left"
      >
        <naj-button
          v-if="isDebtor"
          outlined
          @click="updateCurrentStep(stepsEnum.requestDetails)"
        >
          {{ local.common.back }}
        </naj-button>

        <naj-button
          v-if="isCreditor || isCompetentParty"
          outlined
          @click="updateCurrentStep(stepsEnum.requestApplicantData)"
        >
          {{ local.common.back }}
        </naj-button>

        <naj-button
          :disabled="isViewMode"
          @click="submit()"
        >
          {{ local.bankruptcy.requestReply.send }}
        </naj-button>
      </v-col>
    </v-row>
    <attachment-modal
      ref="attachmentModalComponent"
      :submit-loading="submitLoading"
      :attachment="selectedAttachment"
      :attachment-categories="attachmentTypes"
      :attachments-data="attachments.data"
      modal-button-text=""
      :action-text="local.attachments.add"
      :attachment-type-disabled="attachmentTypeId != -1"
      @onClose="attachmentModalClosed"
      @onSubmit="submitUploadAttachment"
    ></attachment-modal>
    <naj-confirmation
      :show-modal="showVacationModal"
      :title="vacationModal.title"
      :message="vacationModal.message"
      :close-btn-label="local.common.close"
      @cancel="showVacationModal = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import AttachmentsList from './attachments-list';
import AttachmentModal from '@/components/shared/attachment-modal/index';
import { createNamespacedHelpers } from 'vuex';
import { attachmentType } from '@/helpers/enum';
const { mapState, mapActions, mapGetters } = createNamespacedHelpers('BankruptcyModule');
import { getBlobUrl } from '@/helpers/utils';
import { stepsEnum, requestOwnerTypeEnum, requestReplyEnum } from '@/modules/bankruptcy/helpers/enum';
import Vacations from '@/modules/lawsuit/services/vacations';

export default {
  components: {
    AttachmentsList,
    AttachmentModal,
  },
  data() {
    return {
      showVacationModal: false,
      similarRequestsExist: false,
      vacationModal: {
        title: null,
        message: null,
      },
      selectedAttachment: null,
      submitLoading: false,
      showConfirmationModal: false,
      showAttachmentDetailsPanel: false,
      attachmentTypeId: -1,
      isFullScreen: false,
      attachmentType,
      getBlobUrl,
      attachmentTypes: [],
      stepsEnum,
      requestOwnerTypeEnum,
      requestReplyEnum,
    };
  },
  computed: {
    ...mapState([
      'globalAttachmentTypes',
      'attachments',
      'mainRequest']),
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isEditMode',
      'isNotCompleted',
    ]),
    isCreditor() {
      return this.mainRequest.requestOwnerTypeId == requestOwnerTypeEnum.creditor;
    },
    isDebtor() {
      return this.mainRequest.requestOwnerTypeId == requestOwnerTypeEnum.debtor;
    },
    isCompetentParty() {
      return this.mainRequest.requestOwnerTypeId == requestOwnerTypeEnum.competentParty;
    },
    fileUrl() {
      return getBlobUrl(this.selectedAttachment.fileUrl, false);
    },
    requestObjectKey() {
      return this.$route.params.objectKey;
    },
  },
  created() {
    this.getRequestAttachmentTypes(this.requestObjectKey).then((res) => {
      this.attachmentTypes = res.data;
    });
    this.getRequestAttachments(this.requestObjectKey);
  },
  methods: {
    ...mapActions([
      'uploadAttachment',
      'getRequestAttachments',
      'getRequestAttachmentTypes',
      'sendRequest',
    ]),

    submitUploadAttachment(data) {
      this.submitLoading = true;
      data.requestObjectKey = this.requestObjectKey;
      this.uploadAttachment(data)
        .then(() => {
          this.attachmentTypeId = -1;
          this.$refs.attachmentModalComponent.closeModal();
        })
        .finally(() => (this.submitLoading = false));
    },
    attachmentModalClosed() {
      this.attachmentSelected(null);
    },
    attachmentSelected(attachment) {
      this.selectedAttachment = attachment;
    },
    updateCurrentStep(stepId) {
      this.$emit('onUpdateCurrentStep', stepId);
    },
    showAttachmentModal(id) {
      if (id == null || id == undefined) {
        this.$refs.attachmentModalComponent.showModal(this.attachmentTypeId);
      }
      else {
        this.attachmentTypeId = id;
        this.$refs.attachmentModalComponent.showModal(id);
      }
    },

    deleteAttachment() {
      this.attachmentSelected(null);
      this.selectedAttachment = null;
    },

    showGeneralAttachmentModal() {
      this.attachmentTypeId = -1;
      this.attachmentSelected(null);
      this.$refs.attachmentModalComponent.showModal();
    },
    submit() {
      const service = Vacations.check();
      if (service.locked) {
        this.vacationModal = {
          title: this.local.lawsuitRequest.serviceNotAvailable,
          message: service.message,
        };
        this.showVacationModal = true;
      } else {
        this.loading = true;
        const model = {
          objectKey: this.requestObjectKey,
          action: this.isNotCompleted ? requestReplyEnum.completeRequest : requestReplyEnum.submitNewRequest,
        };
        this.sendRequest(model)
          .then(() => {
            this.toaster.success(this.local.bankruptcy.common.sendSuccessfully);
            this.$router.push({ path: '/bankruptcy' });
          })
          .finally(() => { this.loading = false; });
      }
    },
  },
};
</script>

<style lang="scss">
.add-attachment {
  padding-right: 24%;
}
.attachment-row {
  justify-content: center;
}
.attachments-step {
  .attachments-list {
    border-left: 2px solid #75d6ce;
    max-height: 450px;
    overflow-y: auto;
  }
}
.actions-buttons {
  display: flex;
  justify-content: flex-end;
}
.required-docs {
  margin-right: 20px;

  li {
    list-style: disc;
    font-size: 18px;
  }
}
.attachment-file-viewer {
  display: flex;
  justify-content: center;
  height: 600px;
}
.pdf-container {
  position: relative;
  overflow: hidden;
  width: 70%;
  .pdf-viewer {
    height: 100%;
    width: 100%;
    display: inline-block;
  }
  .pdf-actions {
    text-align: center;
    padding: 20px 0;
  }
}

// Small devices (landscape phones, 576px and up)
@media (max-width: 576px) {
  .attachment-details-main-panel {
    display: none;
  }
  .attachment-details-sub-panel {
    display: block;
  }
  .attachments-list {
    border: none !important;
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .attachment-details-main-panel {
    display: none;
  }
  .attachment-details-sub-panel {
    display: block;
  }
  .attachments-list {
    border: none !important;
  }
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .attachment-details-main-panel {
    display: block;
  }
  .attachment-details-sub-panel {
    display: none;
  }
  .attachments-list {
    border-left: 2px solid #75d6ce !important;
  }
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
  .attachment-details-main-panel {
    display: block;
  }
  .attachment-details-sub-panel {
    display: none;
  }
  .attachments-list {
    border-left: 2px solid #75d6ce !important;
  }
}
</style>
